// import json from 'json'
//     ////// an example //////////
//     //  let resp = new Object();
//       resp.data = []
//       resp.data.push(
//         {'created_at': 1576091868821,
//           'image_key': 0,
//           'text': "Earlier comments gone fishing ...",
//           'user': {},
//           'user_id': "5c5457777a88e835cd78aa4a",
//           '_id': "1576091868821"})
//     }
//   return resp


// GET: ask UMU
export async function fetchComments(imageKey) {
  var xhr = new XMLHttpRequest();
  xhr.open("GET", 'http://35.228.113.10/comment.py?id=' + imageKey+1, false);
  xhr.send()
  let array = JSON.parse(xhr.responseText)

  // translate into ML-blink format
  let comments = new Object()
  comments.data = []
  // time offset: 1579117684261 - 1579118291
  for (let t of array) {
    comments.data.push( {'created_at': 1000*t.Time,
                    'image_key': t.aid,
                    'text': t.comment,
                    'user': {},
                    'user_id': "5c5457777a88e835cd78aa4a",
                    '_id': t._id.$oid})
  }
  return comments
}



// POST to UU and UMU
export async function createComment({imageKey, text}) {
  console.log("POST", imageKey)

  // write on report.text
  var xhr1 = new XMLHttpRequest();
  xhr1.open("POST", 'http://35.228.113.10/report.php?image=' + imageKey + '&report=' + text, true);
  xhr1.setRequestHeader('Content-Type', 'application/json');
  xhr1.send(JSON.stringify({value: []}) );
  console.log("POSTed at UU file")

  // write in DB
  var xhr = new XMLHttpRequest();
  xhr.open("GET", 'http://35.228.113.10/comment.py?id=' + imageKey+1  + '&add=' + text, false);
  xhr.send()

  console.log("POSTed at UMU database", (imageKey+1), text)
}






////////////////////////////////////////////////////////////////////// old //////
// import axios from 'axios'
// import {getApiUrl} from '@/api/utils/api-url'

// export async function fetchComments(imageKey) {
//    // const queryParams = isNaN(imageKey) ? '' : `?image_key=${imageKey}`
//    // console.log("Axios called for ID:",queryParams)
//    // let resp = await axios.get(`http://130.239.81.193/comments${queryParams}`)
//    // console.log("Axios response type:", typeof resp)
//    // console.log("Axios response object", resp)
//    // console.log("Axios response data:", resp.data)
//    // return resp
// ask UU //
  // var xhr = new XMLHttpRequest();
  // xhr.open("GET", 'http://35.228.113.10/report.txt/getcom.php?key=' + (imageKey+1), false);
  // xhr.setRequestHeader('Access-Control-Allow-Origin','*');
  // xhr.send()
  // console.log("FETCH", xhr.responseText)
//
//   let resp = new Object()
//   resp.data = []
//   resp.data.push(xhr.response)
//   if (xhr.response.length==0) {
//     console.log('Didnt get back anything');
//

//
//
//}
